import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { Link } from "react-router-dom";
import { useScrollTrigger } from "@mui/material";
import WindyCityLogo from "../../assets/sitelogo.svg";
import DrawerComponent from "../../utils/DrawerComponent";
import { HeaderProps } from "../../data/HeaderProps";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useMsal } from "@azure/msal-react";
import { getTenantIdFromIdTokenClaims } from "../../models/TokenClaim";
import { useGlobal } from "../../utils/GlobalContext";
import { loginRequest } from "../../utils/auth/authConfig";


const pages = [
  {
    id: 1,
    linkName: "Home",
    linkTo: "/",
    visible: false,
  },
  {
    id: 2,
    linkName: "About",
    linkTo: "/about",
    visible: true,
  },
  // {
  //   id: 3,
  //   linkName: "Sessions",
  //   linkTo: "/sessions",
  //   visible: true,
  // },
  // {
  //   id: 4,
  //   linkName: "Speakers",
  //   linkTo: "/speakers",
  //   visible: true,
  // },
  {
    id: 5,
    linkName: "Featured Partners",
    linkTo: "/partners",
    visible: false,
  },
];

const settings = [
  {
    id: 1,
    linkName: "Account",
    linkTo: "/account",
    visible: true,
  },
  {
    id: 2,
    linkName: "My Selections",
    linkTo: "/",
    visible: true,
  },
  {
    id: 3,
    linkName: "Admin",
    linkTo: "/admin",
    visible: true,
  },
  {
    id: 4,
    linkName: "Logout",
    linkTo: "/",
    visible: true,
  },
  {
    id: 5,
    linkName: "Login",
    linkTo: "/",
    visible: true,
  },
];

export default function Header({ showDrawer, ...drawerProps }: HeaderProps) {
  const { instance } = useMsal();
  const {state}= useGlobal();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(showDrawer); 
  
  React.useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        isDrawerOpen &&
        event.target instanceof HTMLElement &&
        !event.target.closest(".MuiDrawer-root") &&
        !event.target.closest(".MuiIconButton-root") 
      ) {
        setIsDrawerOpen(false);
      }
    };

    const handleClick = (event:MouseEvent) => {
      if (
        isDrawerOpen && 
        event.target instanceof HTMLElement &&
        event.target.closest(".MuiDrawer-root") &&
        event.target.closest(".MuiButtonBase-root") 
      ) {
        setIsDrawerOpen(false);
      }
    };

    document.body.addEventListener("click", handleOutsideClick);
    document.body.addEventListener("click", handleClick);


    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
      document.body.removeEventListener("click", handleClick);
    };
  }, [isDrawerOpen]);
  
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (menuitem: string) => {
    setAnchorElUser(null);
    switch (menuitem) {
      case "Logout":
        instance.logout();
        break;
      case "Login":
        instance.loginRedirect(loginRequest);
        break;
      default:
        break;
    }
  };

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  // if admin or owner admin visible=true
  // add security to make sure only admin and owner can access admin page
  return (
    <>
      <ElevationScroll>
        <AppBar position="fixed" sx={{ top: 0 }}>
          <Container maxWidth="xl">
            <Toolbar disableGutters>
            <Box sx={{ display: "flex" }}>
            {showDrawer && !isDrawerOpen && (
                <IconButton
                  size="large"
                  aria-label="open drawer"
                  color="inherit"
                  onClick={handleOpenDrawer}
                >
                  <MenuIcon />
                </IconButton>
              )}
            {showDrawer && isDrawerOpen && (
                <IconButton 
                  onClick={handleCloseDrawer}
                  color="inherit"
                  size="large"
                  aria-label="close drawer"
                  >
                  <ChevronLeftIcon />
              </IconButton>
              )}
            </Box>
              <div>
                <a href="/">
                  <img
                    src={WindyCityLogo}
                    alt="Windy City Conference Logo"
                    height="50px"
                  />
                </a>
              </div>

              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  {pages.map((page) => (
                    <MenuItem
                      key={page.id}
                      onClick={handleCloseNavMenu}
                      sx={{ display: page.visible ? "block" : "none" }}
                    >
                      <Link to={page.linkTo}>
                        <Typography textAlign="center">
                          {page.linkName}
                        </Typography>
                      </Link>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>

              <Box
                sx={{
                  flexGrow: 1,
                  marginLeft: 8,
                  display: { xs: "none", md: "flex" },
                }}
              >
                {pages.map((page) => (
                  <Button
                    key={page.id}
                    onClick={handleCloseNavMenu}
                    sx={{
                      my: 2,
                      color: "gray",
                      display: page.visible ? "block" : "none",
                    }}
                  >
                    <Link to={page.linkTo}>{page.linkName}</Link>
                  </Button>
                ))}
              </Box>

              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title={`${state.UserProfile?.DisplayName===""? "Account": state.UserProfile?.DisplayName + "'s"} Settings`}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0}}>
                    <Avatar alt={state.UserProfile?.DisplayName} src={state.UserProfile?.PictureLink} 
                    sx={{display: instance.getActiveAccount()?.idTokenClaims?'block':'none'}} 
                    />
                    <Avatar alt="Log In" src="../assets/user.svg" 
                    sx={{display: instance.getActiveAccount()?.idTokenClaims?'none':'block'}} 
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {/* {settings.map((setting) => (
                    <MenuItem key={setting.id} onClick={()=> handleCloseUserMenu(setting.linkName)}>
                      <Link to={setting.linkTo}>
                        <Typography textAlign="center">
                          {setting.linkName}
                        </Typography>
                      </Link>
                    </MenuItem>
                  ))} */}

                      <MenuItem key={1} onClick={()=> handleCloseUserMenu("")}
                        sx={{display: instance.getActiveAccount()?.idTokenClaims?'block':'none'}} 
                      >
                        <Link to={"/account"}>
                          <Typography textAlign="center">
                            Account Info
                          </Typography>
                        </Link>
                      </MenuItem>
                      <MenuItem key={1} onClick={()=> handleCloseUserMenu("")}
                        sx={{display: instance.getActiveAccount()?.idTokenClaims?'block':'none'}} 
                      >
                        <Link to={"/admin"}>
                          <Typography textAlign="center">
                            Site Admin
                          </Typography>
                        </Link>
                      </MenuItem>

                      <MenuItem key={4} onClick={()=> handleCloseUserMenu("Logout")}
                        sx={{display: instance.getActiveAccount()?.idTokenClaims?'block':'none'}} 
                      >
                        <Link to={"/"}>
                          <Typography textAlign="center">
                            Logout
                          </Typography>
                        </Link>
                      </MenuItem>

                      <MenuItem key={5} onClick={()=> handleCloseUserMenu("Login")}
                        sx={{display: instance.getActiveAccount()?.idTokenClaims?'none':'block'}}
                      >
                        <Link to={"/"}>
                          <Typography textAlign="center">
                            Login
                          </Typography>
                        </Link>
                    </MenuItem>
                   
                    
                    
                </Menu>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </ElevationScroll>
      <DrawerComponent 
        open={isDrawerOpen} 
        handleDrawerClose={handleCloseDrawer} 
        drawerTabs={drawerProps.drawerTabs} 
        handleMenuItemClick={drawerProps.handleMenuItemClick} 
        renderComponent={drawerProps.renderComponent} 
      />
    </>
  );
}

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement;
}

function ElevationScroll(props: Props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}